export default __webpack_public_path__ + "static/Leaf2-107e181137b731724d9626b5b35098db.png";